import React, { useEffect } from "react";
import "./LegendBox.css";
import { useView } from "src/contexts/ViewContext";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { fromMmToUnit } from "src/helpers/dimensions";
import { isFlatRoofType } from "src/helpers/roofType";

const LegendBox: React.FC = () => {
  const { isOptionVisible } = useView();
  const { state } = useConfiguration();
  const [customText, setCustomText] = React.useState("");

  useEffect(() => {
    const customBlockElement = document.getElementById(
      "configurator-custom-block"
    );

    if (customBlockElement) {
      setCustomText(customBlockElement.innerHTML);
    }
  }, []);

  return (
    <div className={"legend-box"}>
      <div className={`OptionBox ${isOptionVisible ? "" : "hidden"}`}>
        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Dakmaat</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Breedte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.dimensions.width +
              state.dimensions.overhangLeft +
              state.dimensions.overhangRight,
              "cm"
            )}
          </div>

          <div className="optionsBoxTitle">Diepte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.roofType === "kapschuur"
                ? state.dimensions.depth + state.params.kapschuurOverhang
                : state.dimensions.depth +
                state.dimensions.overhangFront +
                state.dimensions.overhangBack,

              "cm"
            )}
          </div>

          <div className="optionsBoxTitle">&nbsp;</div>
          <div className="optionsBoxValue">&nbsp;</div>

        </div>

        <div className="optionBoxSeparator"></div>

        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Fundering</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Breedte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.width, "cm")}
          </div>

          <div className="optionsBoxTitle">Diepte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.depth, "cm")}
          </div>

          <div className="optionsBoxTitle">&nbsp;</div>
          <div className="optionsBoxValue">&nbsp;</div>

        </div>

        <div className="optionBoxSeparator"></div>

        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Berging</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Linker</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.storages.left ? state.dimensions.leftStorageWidth : 0,
              "cm"
            )}
          </div>

          <div className="optionsBoxTitle">Rechter</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.storages.right ? state.dimensions.rightStorageWidth : 0,
              "cm"
            )}
          </div>

          <div className="optionsBoxTitle">&nbsp;</div>
          <div className="optionsBoxValue">&nbsp;</div>

        </div>

        <div className="optionBoxSeparator"></div>

        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Dakafmetingen</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Dakhelling</div>
          <div className="optionsBoxValue">
            {isFlatRoofType(state.roofType) ? 0 : state.dimensions.angle}deg
          </div>

          <div className="optionsBoxTitle">(Nok)hoogte</div>
          <div className="optionsBoxValue">
            {isFlatRoofType(state.roofType)
              ? fromMmToUnit(
                  state.roofType === "modern"
                    ? 2450
                    : state.roofType === "basic"
                      ? 2500
                      : 2600,
                  "cm"
                )
              : fromMmToUnit(state.params.kapschuurNokLabelMm ?? 3090, "cm")}
          </div>

          <div className="optionsBoxTitle">Doorloophoogte</div>
          <div className="optionsBoxValue">
            {isFlatRoofType(state.roofType)
              ? "220"
              : `${fromMmToUnit(state.params.kapschuurSmallHeight, "cm")}`}
          </div>
        </div>
      </div>

      {customText && (
        <div
          className={`custom-block`}
          dangerouslySetInnerHTML={{ __html: customText }}
        ></div>
      )}
    </div>
  );
};

export default LegendBox;
